export const CHANGE_LOCALE = 'localSettings/CHANGE_LOCALE';